import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { LocalCacheManager } from '../../api/managers/local-cache.manager';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Injectable()
export class LoginGuardService implements CanActivate, CanActivateChild {

    constructor(private router: Router,
        private loginAndUserManagerService: LoginAndUserManagerService,
        private localCacheManager: LocalCacheManager) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.checkLogin(state.url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }

    private checkLogin(url: string) {
        if (!this.loginAndUserManagerService.isUserLoggedIn) {
            this.loginAndUserManagerService.redirectUrl = url;

            if (this.localCacheManager.accessToken.length === 0 || !this.localCacheManager.rememberMe) {
                this.router.navigate(['/Welcome'], { queryParams: { signIn: false } });
                return false;
            }
            else {

                // this.syncOverlayService.ShowProgressOverlay();
                this.loginAndUserManagerService.getUserDetails()
                    .subscribe(user => {
                        if (user) {
                            // LoggingService.log('User details were successfully retrieved!', this);
                            // this.syncOverlayService.HideOverlay();
                            this.router.navigate([`${this.loginAndUserManagerService.redirectUrl}`]);
                            return true;
                        }

                        ErrorHandlerService.handleError(this, new Error('User login failed'), 'checkLogin()', false);
                        return false;
                        // this.syncOverlayService.HideOverlay();
                    }, error => {
                        ErrorHandlerService.handleError(this, error, 'checkLogin()', false, false);
                        return false;
                        // this.syncOverlayService.HideOverlay();
                    });

            }

            return false;
        }

        return true;
    }

}
